import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

export interface CourseState {
    materials?: any[];
    [key: string]: any;
}

const initialState: CourseState = {};

export const courseSlice = createSlice({
    name: 'course',
    initialState,
    reducers: {
        setCourse: (state, action: PayloadAction<CourseState>) => {
            return { ...action.payload };
        },
        setMaterialSubmaterials: (state, action: PayloadAction<{ materialId: number; submaterials: any[] }>) => {
            if (!state.materials) return;
            const materialIndex = state.materials.findIndex(
                (m: any) => m.id === action.payload.materialId
            );
            if (materialIndex !== -1) {
                state.materials[materialIndex].submaterials = action.payload.submaterials;
                state.materials[materialIndex].submaterialsLoaded = true;
            }
        },
        setMaterialLoading: (state, action: PayloadAction<{ materialId: number; loading: boolean }>) => {
            if (!state.materials) return;
            const materialIndex = state.materials.findIndex(
                (m: any) => m.id === action.payload.materialId
            );
            if (materialIndex !== -1) {
                state.materials[materialIndex].loading = action.payload.loading;
            }
        },
        setSubmaterialDone: (state, action: PayloadAction<{ materialId: number; submaterialId: number }>) => {
            if (!state.materials) return;
            const materialIndex = state.materials.findIndex(
                (m: any) => m.id === action.payload.materialId
            );
            if (materialIndex === -1) return;
            const submaterials = state.materials[materialIndex].submaterials;
            if (!submaterials) return;
            const submaterialIndex = submaterials.findIndex(
                (sm: any) => sm.id === action.payload.submaterialId
            );
            if (submaterialIndex !== -1) {
                state.materials[materialIndex].submaterials[submaterialIndex].is_done = true;
            }
        },
    }
});

export const { setCourse, setMaterialSubmaterials, setMaterialLoading, setSubmaterialDone } = courseSlice.actions;

export default courseSlice.reducer;